
export const SET_USER = "SET_USER";
export const SET_USER_TOKEN = "SET_USER_TOKEN";
export const SET_USER_ORDER = "SET_USER_ORDER";
export const ACTIVATE_USER = "ACTIVATE_USER";
export const SET_LOADING_STATUS = "SET_LOADING_STATUS";
export const SET_LOADING_MESSAGE = "SET_LOADING_MESSAGE";
export const GET_BOOKS = "GET_BOOKS";
export const SET_CATEGORIES = "GET_CATEGORIES";
export const SET_CREATE_DONATION_STATUS = "SET_CREATE_DONATION_STATUS";
export const SET_ERRORS= "SET_ERRORS";